import Icon, { IconProps } from './Icon';

import aidenPhoto from '../assets/aiden-photo.jpg';
import styled from 'styled-components';

const Card = styled.div`
  background-color: #f4ece6;
  border-radius: 4px;
  box-shadow: 0 7px 30px -10px rgba(0, 0, 0, 0.6);
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: min(360px, 100%);
  flex-shrink: 0;
  flex-basis: 2;
  @media (max-width: 1180px) {
    width: min(360px, 85%);
  }
  @media (max-width: 1024px) {
    flex-direction: column;
    align-items: center;
  }
`;
const Heading = styled.h1`
  font-size: 32px;
  &:after {
    content: ' ';
    display: block;
    width: 40%;
    margin: 0 auto;
    margin-top: 10px;
    border: 1px solid black;
  }
`;
const Image = styled.img`
  border-radius: 50%;
  overflow: hidden;
  max-width: 50%;
  margin-top: 32px;
`;
const PersonalsContainer = styled.div`
  background-color: white;
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: center;
  height: 48px;
  margin-top: auto;
  align-items: center;
  gap: 32px; // ensures spacing is consistent
`;

const PERSONALS: IconProps[] = [
  {
    text: 'Linkedin',
    link: 'https://linkedin.com/in/aidenywl',
  },
  {
    text: 'Github',
    link: 'https://github.com/aidenywl',
  },
  {
    text: 'Google Scholar',
    link: 'https://scholar.google.com/citations?hl=en&user=0dTCfIsAAAAJ',
  },
];
export default function Photocard(): React.ReactElement {
  return (
    <Card>
      <Image alt="aiden profile" src={aidenPhoto} />
      <Heading>Aiden Low</Heading>
      <PersonalsContainer>
        {PERSONALS.map((personalData) => (
          <Icon {...personalData} />
        ))}
      </PersonalsContainer>
    </Card>
  );
}
